import { render } from "./clockPage.vue?vue&type=template&id=c0fe364e"
import script from "./clockPage.vue?vue&type=script&lang=js"
export * from "./clockPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__